import { render, staticRenderFns } from "./PermissionMapEditor.vue?vue&type=template&id=03b6d5ac&"
import script from "./PermissionMapEditor.vue?vue&type=script&lang=ts&"
export * from "./PermissionMapEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionMapEditor.vue?vue&type=style&index=0&id=03b6d5ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports